<template>
    <div>
        <nav class="pagination-wrap d-inline-block mt-15 float-right" aria-label="">
            <ul class="pagination" role="navigation">
                <li class="page-item" :class="{ disabled : current_page == 1}">
                    <a href="#" @click.prevent="decrementPage" class="d-block">
                        <span class="page-link" aria-hidden="true">&lsaquo; Vorherige</span>
                    </a>
                </li>
                <li v-for="link in page_count" class="page-item" :class="{active : current_page == link}">
                    <a href="#" @click.prevent="jumpToPage(link)" class="d-block">
                        <span class="page-link">{{link}}</span>
                    </a>
                </li>
                <li class="page-item" :class="{ disabled : current_page == page_count}" aria-label="Nächste">
                    <a href="#" @click.prevent="incrementPage" class="d-block"><span class="page-link">Nächste &rsaquo;</span></a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>

    // ***********  Localization ***************
    import Lang from 'lang.js'

    // get the data source
    import translations from '../../../vue-translations.js';

    //Bsp.: lang.get('auth.btn_login'));

    // ***********  Localization ***************

    export default {
        props: ['signed_api_get_table_route','page_in'],
        components: {},
        data() {
            return {
                queryValue: {
                    volltextsuche: null,
                    org_gruppe: null,
                    org_element: null,
                    meldungskategorie: null,
                    meldungsvorlage: null,
                    verantwortlicher: null,
                    status: null,
                    time_interval_from: null,
                    time_interval_to: null,
                    switch_eigene: null,
                    switch_risiko: null,
                    page: this.page_in
                },
                item_count: null,
                current_page: null,
                per_page: null,
                lang: null,
            };
        },
        created() {
            var lang = new Lang();

            lang.setLocale(this.locale_in);

            if (lang.getLocale() === 'undefined') {
                lang.setLocale('de');
            }
            lang.setMessages(translations);
            this.lang = lang;

            let self = this;
            this.$eventBus.$on('EMeldersearchQuery', function (queryValue) {
                self.queryValue = queryValue;
                self.getData()
                self.setStoreData();
            });

        },
        mounted() {
            this.queryValue = {
                volltextsuche: this.$store.$store.state.search_emelder.volltextsuche,
                meldungskategorie: this.$store.$store.state.search_emelder.meldungskategorie,
                meldungsvorlage: this.$store.$store.state.search_emelder.meldungsvorlage,
                verantwortlicher: this.$store.$store.state.search_emelder.verantwortlicher,
                status: this.$store.$store.state.search_emelder.status,
                time_interval_from: this.$store.$store.state.search_emelder.time_interval_from,
                time_interval_to: this.$store.$store.state.search_emelder.time_interval_to,
                switch_eigene: this.$store.$store.state.search_emelder.switch_eigene,
                switch_risiko: this.$store.$store.state.search_emelder.switch_risiko,
                page: this.page_in
            }

            console.log("queryValue: ", this.queryValue)

            this.getData();
        },
        watch: {},
        computed: {
            page_count(){
                return (this.item_count && this.per_page)? Math.ceil( this.item_count / this.per_page) : 0;
            }
        },
        methods: {
            getData() {
                $("#cover-spin").show();
                let self = this;
                axios.post(this.signed_api_get_table_route, {
                    search_str: this.queryValue['volltextsuche'],
                    id_org_gruppe: this.queryValue['org_gruppe'],
                    id_org_element: this.queryValue['org_element'],
                    id_meldungskategorie: this.queryValue['meldungskategorie'],
                    id_meldungsvorlage: this.queryValue['meldungsvorlage'],
                    id_verantwortlicher: this.queryValue['verantwortlicher'],
                    time_interval_from: this.queryValue['time_interval_from'],
                    time_interval_to: this.queryValue['time_interval_to'],
                    id_status: this.queryValue['status'],
                    eigene: this.queryValue['switch_eigene'],
                    risiko: this.queryValue['switch_risiko'],
                    page: this.queryValue['page'] ? this.queryValue['page'] : this.page,
                })
                    .then(function (res) {
                        $("#mainTable").html(res.data);

                        setTimeout( function(){
                            self.item_count = parseInt($("#count").val());
                            self.current_page = parseInt($("#current_page").val());
                            self.per_page = parseInt($("#per_page").val());
                            $("#cover-spin").hide();

                        }, 100);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            triggerSearchEvent() {
                this.$eventBus.$emit('EMeldersearchQuery', {
                    volltextsuche: this.queryValue['volltextsuche'],
                    org_gruppe: this.queryValue['org_gruppe'],
                    org_element: this.queryValue['org_element'],
                    meldungskategorie: this.queryValue['meldungskategorie'],
                    meldungsvorlage: this.queryValue['meldungsvorlage'],
                    status: this.queryValue['status'],
                    verantwortlicher: this.queryValue['verantwortlicher'],
                    time_interval_from: this.queryValue['time_interval_from'],
                    time_interval_to: this.queryValue['time_interval_to'],
                    switch_eigene:this.queryValue['switch_eigene'],
                    switch_risiko: this.queryValue['switch_risiko'],
                    page: this.current_page,
                });
            },
            incrementPage(){
                this.current_page = (this.current_page < this.page_count) ? parseInt(this.current_page) + 1 : this.page_count;
                this.triggerSearchEvent();
            },
            decrementPage(){
                this.current_page = (this.current_page > 1) ? parseInt(this.current_page) - 1 : 1;
                this.triggerSearchEvent();
            },
            jumpToPage(page){
                this.current_page = page;
                this.triggerSearchEvent();
            },
            setStoreData(){
                this.$store.$store.commit('storeQueryEMelder', this.queryValue);

                /*  this.$store.state.search_dokman.dokumentenart = this.dokumentenart;
                  this.$store.state.search_dokman.org_element = this.org_element;
                  this.$store.state.search_dokman.org_gruppe = this.org_gruppe;
                  this.$store.state.search_dokman.page = this.page;
                  this.$store.state.search_dokman.redakteur = this.redakteur;
                  this.$store.state.search_dokman.status = this.status;
                  this.$store.state.search_dokman.switch_eigene = this.switch_eigene;
                  this.$store.state.search_dokman.switch_fuehrende = this.switch_fuehrende;
                  this.$store.state.search_dokman.switch_nur_hgb = this.switch_nur_hgb;
                  this.$store.state.search_dokman.volltextsuche = this.volltextsuche;*/
            },
        }
    };
</script>
<style scoped>
</style>
